module.exports = __webpack_public_path__ + "static/img/redmiBook14.64eff90f.png";